"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    RewardRecord: {
      account_id: 'AccountId',
      record_amount: 'Balance'
    }
  }
};
exports.default = _default;